import { formatFileSize } from "@/lib/helpers/formatFileSize";
import { AlertBar2 } from "@/ui2/atoms/AlertBar";

import { ALLOWED_EXTENSIONS, MAX_FILE_SIZE } from "../constants";
import type { PhotoIDUploadStatus } from "../types";

type UploadStatusProps = {
  status: PhotoIDUploadStatus;
};

export function UploadStatus({ status }: UploadStatusProps) {
  switch (status) {
    case "error":
      return (
        <AlertBar2 variant="error">
          <b>Upload Failed: </b>There was an error uploading your photo. Please try again.
        </AlertBar2>
      );

    case "invalid-type":
      return (
        <AlertBar2 variant="error">
          <b>Invalid File Type: </b>Please upload a valid image file ({ALLOWED_EXTENSIONS}).
        </AlertBar2>
      );

    case "too-large":
      return (
        <AlertBar2 variant="error">
          <b>File Size Error: </b>File size exceeds {formatFileSize(MAX_FILE_SIZE)} limit. Please
          upload a smaller file.
        </AlertBar2>
      );

    case "idle":
    case "success":
    case "uploading":
    case "validating":
    default:
      return null;
  }
}
